<template>
  <v-dialog width="600" v-model="dialog" :persistent="isCheck || show">
    <v-card style="border-radius: 10px">
      <v-card-text>
        <v-layout column>
          <v-flex pt-4>
            <img
              style="margin: 0 auto; width: 100px; display: block; height: 100px"
              :src="
                isGood
                  ? 'https://images.cloudclusters.io/3a9ecb99f1884b79905741113878d615/success.png'
                  : 'https://images.cloudclusters.io/1fa7ac8a209e492895a86e67f414a8f6/waitingVerified.png'
              " />
          </v-flex>
          <v-flex pb-4 style="text-align: center" pt-4>
            <span class="fs-4" :style="{ color: isGood ? '#18b23d' : '#ffa700' }">
              {{ isGood ? $t(showGoodText) : $t(showNoGoodText) }}
            </span>
          </v-flex>
          <v-flex pb-3 style="text-align: center">
            <v-btn
              depressed
              class="text-none"
              dark
              v-if="isCheck || type === 'check'"
              color="#ffa700"
              @click="linkToPage">
              {{ $t('btn_check[0]') }}
            </v-btn>
            <v-btn
              depressed
              class="text-none"
              dark
              v-if="type === 'membership' && !isGood"
              color="#ffa700"
              to="/account/information">
              {{ $t('btn_check_billing[0]') }}
            </v-btn>
          </v-flex>
          <v-flex pb-3 style="text-align: center" v-if="type === 'membership' && isGood">
            <v-btn
              depressed
              class="text-none mr-5"
              dark
              :color="isGood ? '#18b23d' : '#ffa700'"
              to="/account/information"
              :title="$t('btn_details[1]')">
              {{ $t('btn_details[0]') }}
            </v-btn>
            <v-btn
              depressed
              class="text-none ml-5"
              dark
              outlined
              :color="isGood ? '#18b23d' : '#ffa700'"
              to="/myvps/ordering"
              @click="getClientInfo(true)">
              {{ $t('btn_order[0]') }}
            </v-btn>
          </v-flex>
          <v-flex pb-3 style="text-align: center" v-if="type === 'package' && isGood">
            <v-btn
              depressed
              class="text-none mr-5"
              dark
              :color="isGood ? '#18b23d' : '#ffa700'"
              :to="`/invoice-detail/${invoiceId}`">
              {{ $t('btn_details[0]') }}
            </v-btn>
            <v-btn
              depressed
              class="text-none ml-5"
              dark
              outlined
              :color="isGood ? '#18b23d' : '#ffa700'"
              @click="linkToPage">
              {{ $t('btn_check[0]') }}
              <!--                            <template>-->
              <!--                                {{to === '/applications' ? $t('menu.apps[0]') : to === '/myvps' ? $t('menu.vps[0]') :  $t('menu.dedicated[0]')}}-->
              <!--                            </template>-->
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import loadingMixin from '@/module/mixins/loading.mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'PendingAccountNotice',
  mixins: [loadingMixin],
  i18n: {
    sharedMessages: {
      en: {
        btn_check: ['Check Your Services'],
        btn_check_billing: ['Check Billing Info'],
        btn_details: ['View Details', 'View the membership details in account information'],
        btn_order: ['Order Now'],
        good_text: [
          'Welcome to the Membership Program.',
          'The invoice is paid. Thank you for your business!',
          'Your billing account is active now. Thank you for your business.'
        ],
        no_good_text: [
          'Payment completed. There will be a review before processing, which may take 2-4 hours. Thank you for your patience.',
          "We're completing a quick verification for your account. Please check your email for the next steps. You can proceed with your payment once verification is complete.",
          'Your free trial order is under review and will be approved within 2 hours. Once approved, it will deploy automatically. Kindly monitor your email for updates. We appreciate your patience.'
        ]
      },
      zh_CN: {
        btn_check: ['查看我的服务'],
        btn_check_billing: ['查看账户信息'],
        btn_details: ['账单详情', '在用户信息中查看会员详情'],
        btn_order: ['去订购'],
        good_text: [
          '欢迎加入会员计划',
          '账单已支付。感谢您的合作！',
          '您的账户现已激活。感谢您的合作。'
        ],
        no_good_text: [
          '付款已完成。在提供服务之前会进行审核，可能需要2-4小时，感谢您的耐心等待。 ',
          '我们正在为您的账户进行快速验证。请查看您的电子邮件，了解后续步骤。验证完成后，您即可继续付款。',
          '您的免费试用订单正在审核中，将在2小时内获得批准。一旦获得批准，将自动部署。请密切关注您的电子邮件以获取更新。感谢您的耐心等待。'
        ]
      }
    }
  },
  props: ['isCheck', 'show'],
  data() {
    return {
      isGood: false,
      type: '',
      to: '',
      callback: null
    }
  },
  computed: {
    showGoodText() {
      switch (this.type) {
        case 'membership':
          return 'good_text[0]'
        case 'package':
          return 'good_text[1]'
        default:
          return 'good_text[2]'
      }
    },
    showNoGoodText() {
      switch (this.type) {
        case 'check':
          return 'no_good_text[0]'
        case 'trial':
          return 'no_good_text[2]'
        default:
          return 'no_good_text[1]'
      }
    }
  },
  methods: {
    open({ isGood, type, to, callback }) {
      this.dialog = true
      this.isGood = isGood || false
      this.type = type || ''
      this.to = to || '/applications'
      this.callback = callback || null
    },
    async linkToPage() {
      if (this.to === this.$route.path) {
        this.callback && (await this.callback())
        this.close()
      } else {
        this.$router.push(this.to)
      }
    },
    ...mapActions('client', ['getClientInfo'])
  },
  created() {
    this.invoiceId = this.$route.params.invoiceId
  }
}
</script>
